import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './index.css';
import './Home.css';
import HeroSection from './HeroSection';

import HowItWorks from './HowItWorks';
import CommunityFeatures from './CommunityFeatures';
import SuccessStories from './SuccessStories';
import ConfidenceBanner from './ConfidenceBanner';
import FeaturedProfiles from './FeaturedProfiles';
import MeaningfulRelationships from './MeaningfulRelationships';
import MembershipPlans from './MembershipPlans';
import FAQSection from './FAQSection';
import VerifiedProfilesBanner from './VerifiedProfilesBanner';
import FindLoveConfidence from './FindLoveConfidence';
import Header from '../../../components/common/Header';
import Footer from '../../../components/common/Footer';

const Home = () => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash, location.pathname]);

  if (!loading && user) {
    let target = '/dashboard';
    if (!profile || profile.profileStatus === 'Draft') {
      target = '/complete-profile';
    } else if (profile.verificationStatus === 'Pending') {
      target = '/verification-pending';
    }
    return <Navigate to={target} replace />;
  }

  return (
    <>
      <Helmet>
        <title>Find Your Perfect Life Partner | Anuppagoundar Tamil Matrimony | Verified Profiles with Gothram & Horoscope Matching</title>
        <meta
          name="description"
          content="Trusted matrimonial platform for Anuppagoundar Tamil community. Find verified matches with gothram verification, horoscope compatibility, and family network verification. Join 10,000+ successful matches."
        />
        <meta property="og:title" content="Find Your Perfect Life Partner | Anuppagoundar Tamil Matrimony | Verified Profiles with Gothram & Horoscope Matching" />
        <meta property="og:description" content="Trusted matrimonial platform for Anuppagoundar Tamil community. Find verified matches with gothram verification, horoscope compatibility, and family network verification. Join 10,000+ successful matches." />
      </Helmet>

      <Header />

      <main>
        <HeroSection />
        <HowItWorks />
        <VerifiedProfilesBanner />
        <CommunityFeatures />
        <SuccessStories />
        <ConfidenceBanner />
        <FeaturedProfiles />
        <MeaningfulRelationships />
        <MembershipPlans />
        <FAQSection />
        <FindLoveConfidence />
      </main>

      <Footer />
    </>
  );
};

export default Home;